module.exports = __webpack_public_path__ + "8ddb168be17c74c263927ebc8d162883.svg";